import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import LicService from '../../../../services/licitacao-auth';
import '../../../../styles/diario.scss'




const Licitacao = () => {
    const [objeto, setObjeto] = useState("");
    const [unidadesGestoras, setUnidadesGestoras] = useState([]);
    const [processo, setProcesso] = useState("");
    const [licitacao, setLicitacao] = useState("");
    const [ano, setAno] = useState("");
    const [valor, setValor] = useState("");
    const [leiBeneficio, setLeiBeneficio] = useState("");
    const [local, setLocal] = useState("Rua Dr Mário Freire Martins, 100");
    const [orgaos, setOrgaos] = useState([]);
    const [modalidade, setModalidade] = useState("");
    const [situacao, setSituacao] = useState("");
    const [observacao, setObservacao] = useState("");
    const [dataPub, setDataPub] = useState("");
    const [dataLic, setDataLic] = useState("");
    const [hora, setHora] = useState("");
    const [orgaoSRP, setOrgaoSRP] = useState("");
    const [anexos, setAnexos] = useState([]);
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);





    const montaForm = async () => {
        const lic = new FormData();
        lic.append("objeto", objeto)
        for (let i = 0; i < unidadesGestoras.length; i++) {
            lic.append('unidadesGestoras', unidadesGestoras[i]);
        }
        lic.append("processo", processo)
        lic.append("licitacao", licitacao)
        lic.append("ano", ano)
        lic.append("valor", valor)
        lic.append("leiBeneficio", leiBeneficio)
        lic.append("local", local);
        for (let i = 0; i < orgaos.length; i++) {
            lic.append('orgaos', orgaos[i]);
        }
        lic.append("modalidade", modalidade);
        lic.append("situacao", situacao);
        lic.append("observacao", observacao);
        lic.append("dataPub", dataPub);
        lic.append("dataLic", dataLic);
        lic.append("hora", hora);
        lic.append("orgaoSRP", orgaoSRP);
        for (let i = 0; i < anexos.length; i++) {
            lic.append('anexos', anexos[i]);
        }
        return lic
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const lic = await LicService.cadastro(dados)
            if (lic.data["cod_lic"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }

    const ponto = (campo) => {
        return campo.replace(/,/g, ".");
    }

    const handleUploadDocumentos = (event) => {
        const files = event.target.files;
        setAnexos(files);
    };

    const handleUnidadeGestoraChange = (e) => {
        const selectedOptions = Array.from(e.target.selectedOptions, (option) => option.value);

        if (selectedOptions.includes('Todas')) {
            // Se 'Todas' estiver incluída nas opções selecionadas, seta todas as unidades gestoras disponíveis
            setUnidadesGestoras(['Prefeitura de Macuco', 'Fundo Municipal de Saúde', 'Fundo Municipal da Educação', 'Fundo Municipal de Assistência Social', 'Fundo Municipal da Criança e do Adolescente', 'Fundo Municipal de Meio Ambiente']);
        } else {
            // Se não, usa diretamente as opções selecionadas
            setUnidadesGestoras(selectedOptions);
        }
    };


    const handleOrgaosChange = (e) => {
        const selectedOptions = Array.from(e.target.selectedOptions, (option) => option.value);

        if (selectedOptions.includes('Todos')) {
            // Se 'Todas' for selecionada, seta todas as unidades gestoras disponíveis
            setOrgaos([
                'Secretaria Municipal de Administração',
                'Secretaria Municipal de Agricultura, Pecuária, Abastecimento e Aquicultura',
                'Secretaria Municipal de Educação',
                'Secretaria Municipal de Esporte, Lazer, Turismo e Cultura',
                'Secretaria Municipal de Fazenda, Planejamento, Orçamento, Indústria e Comércio',
                'Secretaria Municipal de Gabinete e Comunicação',
                'Secretaria Municipal de Controle Interno',
                'Secretaria Municipal de Governo e Gestão',
                'Secretaria Municipal de Meio Ambiente, Urbanismo e Defesa Civil',
                'Secretaria Municipal de Obras e Serviços Públicos',
                'Secretaria Municipal de Saúde e Prevenção à Dependência Química',
                'Secretaria Municipal de Desenvolvimento Social e Direitos Humanos',
                'Secretaria Municipal de Trabalho, Envelhecimento Saudável e da Juventude',
                'Secretaria Municipal de Turismo'
            ]);
        } else {
            // Se não for 'Todas', adiciona ou remove a unidade gestora selecionada
            setOrgaos(selectedOptions);
        }
    };

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setObjeto("");
        setUnidadesGestoras("");
        setProcesso("");
        setLicitacao("");
        setAno("");
        setValor("");
        setLeiBeneficio("");
        setLocal("");
        setOrgaos("");
        setModalidade("");
        setSituacao("");
        setObservacao("");
        setDataPub("");
        setDataLic("");
        setHora("");
        setOrgaoSRP("");
        setAnexos("");
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={4}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Objeto">
                                <FloatingLabel
                                    label="Objeto"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="textarea"
                                        name="objeto"
                                        value={objeto}
                                        onChange={e => setObjeto(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="UnidadeGestora">
                                <FloatingLabel label="Unidade Gestora" className="mb-3">
                                    <Form.Select
                                        required
                                        aria-label="Unidade Gestora"
                                        className="varios-g"
                                        name="unidadeGestora"
                                        onChange={handleUnidadeGestoraChange}
                                        multiple
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Todas">Todas</option>
                                        <option value="Prefeitura de Macuco">Prefeitura Municipal de Macuco</option>
                                        <option value="Fundo Municipal de Saúde">Fundo Municipal de Saúde</option>
                                        <option value="Fundo Municipal da Educação">Fundo Municipal da Educação</option>
                                        <option value="Fundo Municipal de Assistência Social">Fundo Municipal de Assistência Social</option>
                                        <option value="Fundo Municipal da Criança e do Adolescente">Fundo Municipal da Criança e do Adolescente</option>
                                        <option value="Fundo Municipal de Meio Ambiente">Fundo Municipal de Meio Ambiente</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="processo">
                                <FloatingLabel
                                    label="Processo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="processo"
                                        value={processo}
                                        onChange={e => setProcesso(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Licitação">
                                <FloatingLabel
                                    label="Licitação (com ano)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="licitacao"
                                        value={licitacao}
                                        onChange={e => setLicitacao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Valor da Licitação">
                                <FloatingLabel
                                    label="Valor da Licitação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(ponto(e.target.value))} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Órgão Solicitante">
                                <FloatingLabel
                                    label="Órgão Solicitante"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Órgão Solicitante"
                                        className="varios-g"
                                        name="orgaos"
                                        onChange={handleOrgaosChange}
                                        multiple
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Todos">Todos</option>
                                        <option value="Secretaria Municipal de Administração">Administração</option>
                                        <option value="Secretaria Municipal de Agricultura, Pecuária, Abastecimento e Aquicultura">Agricultura, Pecuária, Abastecimento e Aquicultura</option>
                                        <option value="Secretaria Municipal de Educação">Educação</option>
                                        <option value="Secretaria Municipal de Esporte, Lazer, Turismo e Cultura">Esporte, Lazer, Turismo e Cultura</option>
                                        <option value="Secretaria Municipal de Fazenda, Planejamento, Orçamento, Indústria e Comércio">Fazenda, Planejamento, Orçamento, Indústria e Comércio</option>
                                        <option value="Secretaria Municipal de Gabinete e Comunicação">Gabinete e Comunicação</option>
                                        <option value="Secretaria Municipal de Controle Interno">Controle Interno</option>
                                        <option value="Secretaria Municipal de Governo e Gestão">Governo e Gestão</option>
                                        <option value="Secretaria Municipal de Meio Ambiente, Urbanismo e Defesa Civil">Meio Ambiente, Urbanismo e Defesa Civil</option>
                                        <option value="Secretaria Municipal de Obras e Serviços Públicos">Obras e Serviços Públicos</option>
                                        <option value="Secretaria Municipal de Saúde e Prevenção à Dependência Química">Saúde e Prevenção à Dependência Química</option>
                                        <option value="Secretaria Municipal de Desenvolvimento Social e Direitos Humanos">Desenvolvimento Social e Direitos Humanos</option>
                                        <option value="Secretaria Municipal de Trabalho, Envelhecimento Saudável e da Juventude">Trabalho, Envelhecimento Saudável e da Juventude</option>
                                        <option value="Secretaria Municipal de Turismo">Turismo</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Modalidade">
                                <FloatingLabel
                                    label="Modalidade"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Modalidade"
                                        name="modalidade"
                                        onChange={e => setModalidade(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Carta Convite">Carta Convite</option>
                                        <option value="Concorrência">Concorrência</option>
                                        <option value="Chamamento Público para Credenciamento em Saúde">Chamamento Público para Credenciamento em Saúde</option>
                                        <option value="Concurso">Concurso</option>
                                        <option value="Leilão">Leilão</option>
                                        <option value="Pregão">Pregão</option>
                                        <option value="Pregão Eletrônico">Pregão Eletrônico</option>
                                        <option value="Ata de Adesão - SRP">Ata de Adesão - SRP</option>
                                        <option value="Tomada de Preço">Tomada de Preço</option>
                                        <option value="Dispensa">Dispensa</option>
                                        <option value="Inexigibilidade">Inexigibilidade</option>
                                        <option value="COVID">COVID</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Situação">
                                <FloatingLabel
                                    label="Situação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Situação"
                                        name="situacao"
                                        onChange={e => setSituacao(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Publicada">Publicada</option>
                                        <option value="Em Andamento">Em Andamento</option>
                                        <option value="Homologada">Homologada</option>
                                        <option value="Cancelada">Cancelada</option>
                                        <option value="Deserta">Deserta</option>
                                        <option value="Suspensa">Suspensa</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Benefício Lei 123">
                                <FloatingLabel
                                    label="Benefício Lei 123"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Benefício Lei 123"
                                        name="leiBeneficio"
                                        onChange={e => setLeiBeneficio(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Ampla Concorrência">Ampla Concorrência</option>
                                        <option value="Exclusivo para MEI/ME e EPP">Exclusivo para MEI/ME e EPP</option>
                                        <option value="Exigência Subcontratação ME">Exigência Subcontratação ME</option>
                                        <option value="Com Itens Exclusivos">Com Itens Exclusivos</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        {modalidade === "Ata de Adesão - SRP" ?
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Orgão SRP">
                                <FloatingLabel
                                    label="Órgão Gerenciador"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="orgaoSRP"
                                        value={orgaoSRP}
                                        onChange={e => setOrgaoSRP(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col> : null }
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Observação">
                                <FloatingLabel
                                    label="Observação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="textarea"
                                        name="observacao"
                                        value={observacao}
                                        onChange={e => setObservacao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="DataPub">
                                <FloatingLabel
                                    label="Data da Publicação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataPub"
                                        value={dataPub}
                                        onChange={e => setDataPub(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="DataLic">
                                <FloatingLabel
                                    label="Data da Licitação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="date"
                                        name="dataLic"
                                        value={dataLic}
                                        onChange={e => setDataLic(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Hora">
                                <FloatingLabel
                                    label="Hora"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        aria-label="Hora"
                                        name="hora"
                                        onChange={e => setHora(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="9h">9H</option>
                                        <option value="10h">10H</option>
                                        <option value="11h">11H</option>
                                        <option value="12h">12H</option>
                                        <option value="13h">13H</option>
                                        <option value="14h">14H</option>
                                        <option value="15h">15H</option>
                                        <option value="16h">16H</option>
                                        <option value="17h">17H</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={6}>
                            <Form.Group className="mb-3" controlId="aviso">
                                <Form.Label>Anexos</Form.Label>
                                <Form.Control
                                    type="file"
                                    name="documentos"
                                    onChange={handleUploadDocumentos}
                                    accept=".pdf, .xlsx, .xls"
                                    multiple // Permite múltiplos arquivos
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/licitacao'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Licitação cadastrada com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outra
                </Button>
                <br /><br />
                <Link to={'/restrito/licitacao/listar/todas'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de todas licitações
                    </Button>
                </Link>
                <br /> <br />
                <Link to={'/restrito/licitacao/listar/andamento'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Licitações em Andamento
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/licitacao/listar/avisos'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Avisos de Licitação
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/licitacao/listar/encerradas'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Licitações Encerradas
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/licitacao'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Licitacao;